// String formats the admin contracts share, accepting what the Zod contracts they
// replace accepted, so stored and in-flight values keep decoding.
import { Schema } from 'effect';

const isParsableUrl = (value: string): boolean => URL.canParse(value);

/** An absolute URL `new URL` parses, as `z.url()` accepted it. */
export const HttpUrl = Schema.String.check(
  Schema.makeFilter((value: string) => isParsableUrl(value) || 'expected an absolute URL'),
).annotate({ format: 'uri' });
export type HttpUrl = typeof HttpUrl.Type;

// Zod's `z.uuid()` pattern: RFC 9562 versions 1-8 with the RFC variant, plus the
// nil and the lowercase max UUID.
const UUID =
  /^(?:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/u;

/** A UUID string. */
export const Uuid = Schema.String.check(Schema.isPattern(UUID, { expected: 'a UUID' })).annotate({
  format: 'uuid',
});
export type Uuid = typeof Uuid.Type;
